import { createSlice } from "@reduxjs/toolkit";

export const AvoirInitialState = {
  avoir:[],
  avoirs: [],
  avoirLog:[],

   // Persistent state for avoirs
  avoirsPageIndex: 0,
  avoirsSearchQuery: '',
};

export const avoirSlice = createSlice({
  name: "avoir",
  initialState: AvoirInitialState,
  reducers: {
    setAvoir: (state, action) => {
      state.avoir = action.payload.avoir;
    },
    setAvoirs: (state, action) => {
      state.avoirs = action.payload.avoirs;
    },
    setAvoirLog:(state,action)=>{
      state.avoirLog =action.payload.avoirLog
    },
     // Avoirs persistence
    setAvoirsPageIndex: (state, action) => {
      state.avoirsPageIndex = action.payload;
    },
    setAvoirsSearchQuery: (state, action) => {
      state.avoirsSearchQuery = action.payload;
    },
  },
});

export const { setAvoir,setAvoirs ,setAvoirLog,setAvoirsPageIndex,setAvoirsSearchQuery} = avoirSlice.actions;
